import { Http } from "../axios/interceptors";

export const createTemplate = async (body) =>
  Http("POST", "/WhatsApp/templates/create", null, body);
